import { render, staticRenderFns } from "./ContractTabs.vue?vue&type=template&id=5ed0f4d0"
import script from "./ContractTabs.vue?vue&type=script&lang=js"
export * from "./ContractTabs.vue?vue&type=script&lang=js"
import style0 from "./ContractTabs.vue?vue&type=style&index=0&id=5ed0f4d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports